import React, { useEffect, useCallback } from "react";
import { animateScroll as scroll } from "react-scroll";
import usePersistedState from "../../hooks/usePersistedState";
import { useStore } from "../../store/store";
import { useIsReadOnlyContextProviderContext } from "../../context/IsReadOnlyContext";

function useWrapperSelector(
  submitPressed: boolean,
  editQuote: boolean
) {
  const materialChoice = useStore((state) => state.quote.material);
  const doorType = useStore((state) => state.quote.doorType);
  const isBifold = doorType?.includes("Bi-fold");
  const isBifoldDoor = doorType === "Bi-fold";
  const isBifoldCorner = doorType === "Bi-fold Zero Corner";
  const isBifoldWindow = doorType === "Bi-fold Window";
  const isBifoldCombo = doorType === "Bi-fold Door/Window Combo";
  const isSlider = doorType === "Slider";
  const isSwing = doorType === "Swing";
  const isPivot = doorType === "Pivot";
  const isFixedPanel = doorType === "Fixed Panel";
  const isAluminum = materialChoice === "All Aluminum";
  const editBtn = useStore((state) => state.isEdit);
  const exactConfig = useStore((state) => state.quote.exactConfig);
  const sliderP = useStore((state) => state.quote.sliderPocket);
  const sliderPocketing = sliderP === "With Pocket";
  const woodSpecies = useStore((state) => state.quote.woodSpecies);
  const paintOptionShown = !woodSpecies
    ? ""
    : woodSpecies && woodSpecies.includes("Paint-Grade")
      ? "paint"
      : "stain";

  const [isHandleHeightShown, setIsHandleHeightShown] = usePersistedState(
    "isHandleHeightShown",
    false,
    submitPressed,
    editQuote,
  );

  const [hideHandles, setHideHandles] = usePersistedState(
    "hideHandles",
    false,
    submitPressed,
    editQuote,
  );

  const [sliderConfig, setSliderConfig] = usePersistedState(
    "sliderConfig",
    "",
    submitPressed,
    editQuote,
  );

  const { setToReadOnly, setToNotReadOnly } = useIsReadOnlyContextProviderContext();

  const isExtCladShown = materialChoice?.includes("Clad") ? true : false;

  useEffect(() => {
    if (!submitPressed) return;
    scroll.scrollToTop();
  }, [submitPressed]);

  const showHandleHeight = useCallback((isHeightOver9ft: boolean) => {
    setIsHandleHeightShown(isHeightOver9ft);
  }, []);

  const hideHandlesWithEvenConfigs = useCallback(
    (isEvenConfigs: boolean) => setHideHandles(isEvenConfigs),
    [],
  );

  return {
    hideHandlesWithEvenConfigs,
    showHandleHeight,
    isExtCladShown,
    sliderConfig,
    setSliderConfig,
    hideHandles,
    isHandleHeightShown,
    paintOptionShown,
    sliderPocketing,
    exactConfig,
    editBtn,
    materialChoice,
    isAluminum,
    isBifold,
    isBifoldDoor,
    isBifoldCorner,
    isBifoldWindow,
    isSlider,
    isSwing,
    isPivot,
    isFixedPanel,
    isBifoldCombo,
  };
}

export default useWrapperSelector;
